import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaobloqueioveiculoprefaturagerada(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaobloqueioveiculoprefaturagerada/FIND_BLOQUEIOVEICULOS':
        case '@operacaobloqueioveiculoprefaturagerada/FIND_VEICULOSPREGERADA':
      case '@operacaobloqueioveiculoprefaturagerada/UPDATE_BLOQUEIOVEICULOS':
      case '@operacaobloqueioveiculoprefaturagerada/DELETE_BLOQUEIOVEICULOS':
      case '@operacaobloqueioveiculoprefaturagerada/STORE_BLOQUEIOVEICULOS':
      case '@operacaobloqueioveiculoprefaturagerada/BLOQUEIOVEICULOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaobloqueioveiculoprefaturagerada/SUCCESS_REMOVE':
      case '@operacaobloqueioveiculoprefaturagerada/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaobloqueioveiculoprefaturagerada/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaobloqueioveiculoprefaturagerada;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaobloqueioveiculoprefaturagerada/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaobloqueioveiculoprefaturagerada;
        break;
      }

      case '@operacaobloqueioveiculoprefaturagerada/RECORD_FILTERING':
        case '@operacaobloqueioveiculoprefaturagerada/RECORD_FILTERING_VEICULO': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
